import React__default from 'react';
import PropTypes from 'prop-types';
import { SliderHeaderWrapper, SliderTitle, SliderValueWrapper, SliderHeaderText } from './SliderHeader.styles.js';
import ButtonIcon from '../../Button/ButtonIcon/ButtonIcon.js';
import Toggle from '../../Toggle/index.js';
import Label from '../../../Label/Label.js';

var SliderHeader = function SliderHeader(_ref) {
  var _ref$isSliderActive = _ref.isSliderActive,
    isSliderActive = _ref$isSliderActive === void 0 ? true : _ref$isSliderActive,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? undefined : _ref$label,
    _ref$htmlFor = _ref.htmlFor,
    htmlFor = _ref$htmlFor === void 0 ? undefined : _ref$htmlFor,
    _ref$onDelete = _ref.onDelete,
    onDelete = _ref$onDelete === void 0 ? undefined : _ref$onDelete,
    _ref$onToggleChange = _ref.onToggleChange,
    onToggleChange = _ref$onToggleChange === void 0 ? undefined : _ref$onToggleChange,
    _ref$valueLabel = _ref.valueLabel,
    valueLabel = _ref$valueLabel === void 0 ? undefined : _ref$valueLabel,
    _ref$deleteTitle = _ref.deleteTitle,
    deleteTitle = _ref$deleteTitle === void 0 ? 'Remove slider' : _ref$deleteTitle,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$toggleLabel = _ref.toggleLabel,
    toggleLabel = _ref$toggleLabel === void 0 ? 'Disable slider' : _ref$toggleLabel,
    _ref$unit = _ref.unit,
    unit = _ref$unit === void 0 ? undefined : _ref$unit;
  return React__default.createElement(SliderHeaderWrapper, {
    "data-testid": testId
  }, React__default.createElement(SliderTitle, null, typeof onToggleChange === 'function' && React__default.createElement(Toggle, {
    onChange: onToggleChange,
    checked: isSliderActive,
    label: toggleLabel,
    hasLabel: false,
    size: "small",
    id: "disable-slider"
  }), label && React__default.createElement(Label, {
    htmlFor: htmlFor,
    size: "medium"
  }, label)), React__default.createElement(SliderValueWrapper, {
    $isSliderActive: isSliderActive
  }, valueLabel && React__default.createElement(SliderHeaderText, {
    variant: "headingSmall",
    $isSliderActive: isSliderActive
  }, valueLabel), unit && React__default.createElement(SliderHeaderText, {
    variant: "bodySmall",
    $isSliderActive: isSliderActive
  }, unit), typeof onDelete === 'function' && React__default.createElement(ButtonIcon, {
    displayText: "hidden",
    disabled: !isSliderActive,
    variant: "ghost",
    onClick: onDelete,
    title: deleteTitle,
    size: "small",
    icon: "Delete"
  })));
};
SliderHeader.propTypes = {
  deleteTitle: PropTypes.string,
  htmlFor: PropTypes.string,
  isSliderActive: PropTypes.bool,
  label: PropTypes.string,
  onDelete: PropTypes.func,
  onToggleChange: PropTypes.func,
  testId: PropTypes.string,
  toggleLabel: PropTypes.string,
  unit: PropTypes.string,
  valueLabel: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export { SliderHeader };
//# sourceMappingURL=SliderHeader.js.map
